import request from './requestWrapper';

// Types
import { ResourceType } from '../types/resourcesTypes';


function getResources() {
  return request({
    url: 'resources/getResources',
    method: 'GET'
  });
}
function createOrUpdate(data: ResourceType){
  return request({
    url: 'resources/createOrUpdate',
    method: 'POST',
    data
  })
}

export default {
  getResources, createOrUpdate
}